export const endpoints = {
  auth: {
    signUp: {
      url: '/auth/signup',
    },
    resetPassword: {
      url: '/auth/reset',
    },
  },
  payments: {
    planInfo: {
      url: '/payment/plans/quota',
    },
  },
  arc: {
    base: {
      url: '/arc',
    },
    byId: (id) => ({
      url: `/arc/${id}`,
    }),
    favorites: {
      url: '/arc/favorites',
    },
    getInstallation: (id) => ({
      url: `/arc/${id}/getInstallation`,
    }),
    checkInstallation: (id) => ({
      url: `/arc/${id}/checkInstallation`,
    }),
    live: {
      url: '/arc/live',
    },
    addToFavorites: {
      url: '/arc/addToFavorites',
    },
    removeFromFavorites: {
      url: '/arc/removeFromFavorites',
    },
    published: (id) => ({
      url: `/arc/${id}/published`,
    }),
    copy: (id) => ({
      url: `/arc/${id}/copy`,
    }),
    uploadEDetail: (ampId) => ({
      url: ampId ? `/arc/e-detailer/upload?ampId=${ampId}` : `/arc/e-detailer/upload`,
    }),
    reimportSlides: (id) => ({
      url: `/arc/e-detailer/${id}/reimport`,
    }),
    generatePdf: (id) => ({
      url: `/arc/${id}/generatePdf`,
    }),
  },
  domain: {
    getDomains: (ampId) => ({
      url: `/arc/${ampId}/domain`,
    }),
    saveDomain: (ampId) => ({
      url: `/arc/${ampId}/domain`,
    }),
    updateDomain: (ampId, domainId) => ({
      url: `/arc/${ampId}/domain/${domainId}`,
    }),
    deleteDomain: (ampId, domainId) => ({
      url: `/arc/${ampId}/domain/${domainId}`,
    }),
    publish: (ampId) => ({
      url: `/arc/${ampId}/domain/publish`,
    }),
    checkDNS: (ampId, domainId) => ({
      url: `/arc/${ampId}/domain/${domainId}/verify`,
    }),
  },
  media: {
    base: (ampId) => ({
      url: `/arc/${ampId}/media`,
    }),
    getAll: (ampId) => ({
      url: `/arc/${ampId}/media/find`,
    }),
    delete: (ampId, fileId) => ({
      url: `/arc/${ampId}/media/${fileId}`,
    }),
  },
  organization: {
    base: {
      url: '/organization',
    },
    members: {
      url: '/organization/members',
    },
    invite: {
      url: '/organization/sendInvites',
    },
    transfer: {
      url: '/organization/transfer',
    },
  },
  payment: {
    billing: {
      url: '/payment/billing',
    },
    setup: {
      url: '/payment/setup',
    },
    checkout: {
      url: '/payment/checkout',
    },
    portal: {
      url: '/payment/portal',
    },
    subscription: {
      url: '/payment/subscription',
    },
    plans: {
      url: '/payment/plans',
    },
    planById: (planId) => ({
      url: `/payment/plans/${planId}`,
    }),
    taxIds: {
      url: '/payment/taxIds',
    },
  },
  plugin: {
    base: {
      url: '/plugin',
    },
    byId: (id) => ({
      url: `/plugin/${id}`,
    }),
  },
  role: {
    base: {
      url: '/role',
    },
    getById: (id) => ({
      url: `/role/${id}`,
    }),
  },
  conversation: {
    conversationsByAmpId: (ampId) => ({
      url: `/arc/${ampId}/conversation`,
    }),
  },

  insights: {
    session: (id) => ({ url: `/arc/${id}/insights/session` }),
    export: (id) => ({ url: `/arc/${id}/insights/session/export` }),
  },
};
